import { Notifications, Manager } from "@twilio/flex-ui";
import { NotificationIds } from "../flex-hooks/notifications/TransferResult";
import ChatTransferService, { buildRemovePartiticipantAPIPayload } from "../helpers/APIHelper";
import { RemoveChatParticipantActionPayload } from "../types/ActionPayloads";

export const name = "RemoveChatParticipant";

export const handle = async (payload: RemoveChatParticipantActionPayload) => {
  const { conversationSid, task, interactionParticipantSid } = payload;
  console.log("handleRemoveChatParticipant", task, interactionParticipantSid);

  const removePartcipantAPIPayload = await buildRemovePartiticipantAPIPayload(
    conversationSid,
    task,
    interactionParticipantSid
  );

  if (!removePartcipantAPIPayload) {
    console.error("error building removePartcipantAPIPayload");
    Notifications.showNotification(NotificationIds.ChatRemoveParticipantFailed);
    return;
  }

  try {
    const manager = Manager.getInstance();
    await new ChatTransferService(manager).removeParticipantAPIRequest(removePartcipantAPIPayload);

    Notifications.showNotification(NotificationIds.ChatRemoveParticipantSuccess);
  } catch (error) {
    console.error("remove participant API request failed", error);
    Notifications.showNotification(NotificationIds.ChatRemoveParticipantFailed);
  }
};
